import React, { Component } from "react";
import TagActions from "../actions/TagActions";
import TagStore from "../stores/TagStore";
import connectToStores from "alt-utils/lib/connectToStores";
import { TagFilmTable } from "./partials/tag-view/tag-film-table.jsx";
import { TagEventTable } from "./partials/tag-view/tag-event-table.jsx";
import EventBucketStore from "../stores/EventBucketStore";

class Tag extends Component {
  static getStores() {
    return [TagStore, EventBucketStore];
  }

  static getPropsFromStores() {

    return {
      getTagById: TagStore.getTagById,
      getEventBucketById: EventBucketStore.getEventBucketById
    };
  }

  componentDidMount() {
    TagActions.fetchOne(this.props.params.tagId)
  }

  render() {
    const tag = this.props.getTagById(this.props.params.tagId)
    const eventBucket = this.props.getEventBucketById(this.props.params.eventBucketId);

    return (
      <div>
        <h1>{tag ? tag.name : "Unnamed Tag"}</h1>
        <div style={{ display: "flex", flexDirection: "row" }}>
          <div style={{ display: "flex", flexDirection: "column", justifyContent: "center" }}>
            <h4>Is this tag hidden?</h4>
            <text>{tag && tag.visible ? "No" : "Yes"}</text>
          </div>
          <div style={{
            display: "flex",
            flexDirection: "column",
            marginLeft: 12,
          }}>
            <h4>What color is this tag?</h4>
            <div style={{
              width: 12,
              height: 12,
              backgroundColor: tag ? tag.color : "#FFF",
              marginTop: 4
            }} />
          </div>
        </div>
        <TagFilmTable
          eventBucketId={this.props.params.eventBucketId}
          tagId={this.props.params.tagId}
        />
        <TagEventTable
          eventBucketId={this.props.params.eventBucketId}
          tagId={this.props.params.tagId}
          timezone={eventBucket ? eventBucket.timezone : "America/Kentucky/Monticello"}
        />
      </div>
    )
  }
}

export default connectToStores(Tag);


// WEBPACK FOOTER //
// ./src/app/components/tag.jsx